import './simplewidget.css';

const SimpleWidget = ({ label, value, icon }) => {
  return (
    <div className="simpleWidget">
      <div className="simpleWidgetHeader">
        {icon && <span className="simpleWidgetIcon">{icon}</span>}
        <span className="simpleWidgetLabel">{label}</span>
      </div>
      <div className="simpleWidgetDivider" />
      <div className="simpleWidgetValue">
        {value ?? "–"}
      </div>
    </div>
  );
};

export default SimpleWidget;
